import { createReducer } from '@reduxjs/toolkit'
import { setAIFilters, setPendingMagicTemplatesCategoryId, setStyleFromCreatePage } from './action'
import { FaceSwapDataObject } from '@/scenes/Editor/components/FloatingImprover/faceSwapStaticData'

// export interface FaceSwapDataObjectWithStyleId extends FaceSwapDataObject {styleId: number, categoryId: number, aspectRatio: number, quality: number, model: string}

export interface AIFIlterInterface {
  aiFilters: any[],
  styleFromCreatePage: FaceSwapDataObject
  pendingMagicTemplatesCategoryId: string | null
}
const initialState: AIFIlterInterface = {
  aiFilters: [],
  styleFromCreatePage: null,
  pendingMagicTemplatesCategoryId: null,
}

export const aiFiltersReducer = createReducer(initialState, builder => {
  builder.addCase(setAIFilters, (state, { payload }) => {
    state.aiFilters = payload
  })
  builder.addCase(setStyleFromCreatePage, (state, { payload }) => {
    state.styleFromCreatePage = payload
  })
  builder.addCase(setPendingMagicTemplatesCategoryId, (state, { payload }) => {
    state.pendingMagicTemplatesCategoryId = payload
  })
})
